import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import { Context } from "%/dynamic-component-editor/classes/context-v2";
import { STORY_ENTITY_TYPE } from "%/dynamic-component-editor/classes/platform-standard-entities";
import { camelToTitleCase } from "@bloglovin/vue-framework";

export default class StoryContextSelection extends BaseOption {
  static userInterfaceComponent = () => ({
    label: "Story",
    component: inspectorTools.SIMPLE_PICKER,
    props: {
      "data-test": "story-context-selection",
      options: Object.entries(Context.contexts)
          .filter(([, ctx]) => ctx.entityType === STORY_ENTITY_TYPE)
          .map(([name]) => ({ id: name, name: camelToTitleCase(name, true) })),
    },
  });

  static defaultValue = "";
}
